import React from "react";
import PropTypes from "prop-types";

const RowsPerPageSelector = ({ rowsPerPage, setRowsPerPage }) => {
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
  };

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="rows-per-page">Rows per page:</label>
      <select
        id="rows-per-page"
        onChange={handleRowsPerPageChange}
        value={rowsPerPage}
        className="border border-gray-300 rounded p-2"
      >
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>
    </div>
  );
};

export default RowsPerPageSelector;

RowsPerPageSelector.propTypes = {
  rowsPerPage: PropTypes.number.isRequired,
  setRowsPerPage: PropTypes.func.isRequired,
};
